/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import PageTitle from '../../../../client/js/components/PageTitle'
import InvoiceListCard, { InvoiceListQuery } from '../invoice/InvoiceListCard'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import { Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import LeaseBreadcrumb from './LeaseBreadcrumb'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'
import { getInvoiceCreateLink } from '../../lib/links/invoiceLinks'
import { parseNumber } from '@jalik/form-parser'

function LeaseInvoiceListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const leaseId = parseNumber(params.id)
  const lease = useRouteLoaderData<Lease>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: InvoiceListQuery = useMemo(() => ({
    ...searchParams,
    leaseId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'invoices',
    defaultMessage: 'Factures'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <LeaseBreadcrumb
          lease={lease}
          title={title}
        />

        <InvoiceListCard
          createLink={getInvoiceCreateLink({ leaseId })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default LeaseInvoiceListPage
